import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export async function completeNote(note: Note): Promise<void> {
  const max =
    (
      await supabase
        .from<Note>('notes')
        .select('order')
        .order('order', {
          ascending: false,
        })
        .limit(1)
        .single()
    ).data?.order || note.order + 10;

  await supabase
    .from<Note>('notes')
    .update({ ...note, order: max + 1 })
    .eq('id', note.id);
}
